import formatCurrency, {
  formatCurrencyNoDecimals,
} from '@/utilities/format-currency';
import classNames from 'classnames';
import {ComponentChildren} from 'preact';

/**
 * Label for the buttons in the DeliverySelector component.
 */
export default function DeliverySelectorLabel({
  children,
  compareAtPrice,
  currency,
  locale,
  formatMoneyWithDecimals = true,
  price,
}: DeliverySelectorLabelProps) {
  const formatMoney = formatMoneyWithDecimals
    ? formatCurrency
    : formatCurrencyNoDecimals;

  return (
    <span className="flex w-full items-center justify-between whitespace-nowrap font-normal">
      {children}
      <span className="flex flex-wrap-reverse items-start justify-end gap-x-1 text-lg font-semibold">
        {
          <span
            className={classNames(
              'text-deep-ocean-blue/50 line-through transition-opacity duration-150 ease-in-out',
              {
                'opacity-1 max-w-16 scale-x-100': compareAtPrice > price,
                'max-w-0 scale-x-0 opacity-0': compareAtPrice <= price,
              }
            )}
          >
            {compareAtPrice && !isNaN(compareAtPrice)
              ? formatMoney(compareAtPrice, currency, locale)
              : ''}
          </span>
        }

        <span>{formatMoney(price, currency, locale)}</span>
      </span>
    </span>
  );
}

export type DeliverySelectorLabelProps = {
  children: ComponentChildren;
  compareAtPrice: number;
  currency: string;
  locale?: string;
  formatMoneyWithDecimals?: boolean | null;
  price: number;
};
